module.exports = __webpack_public_path__ + "static/media/posts-5.62280f36.jpg";